import { Dispatch, FC, useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Action } from 'redux';

import { Earning } from '../../lib/models/fundamental/types';
import { RootState } from '../../lib/store';
import { getPreviousEarningsCacheKey } from '../../lib/store/fundamental/helpers';
import { getPreviousEarnings as getPreviousEarningsData } from '../../lib/store/fundamental/index';
import { FundamentalCall, GetPreviousEarningsPayload } from '../../lib/store/fundamental/types';
import { isCallStatusPending } from '../../lib/util/error-handling/StatusByCallHelpers';

import EarningsReportDetails from '../../shared_components/EarningsCalendar/components/EarningsReportDetails/EarningsReportDetails';

type OwnProps = {
  earning: Earning;
  onClose: () => void;
};
type Props = OwnProps & ReduxProps;

const EarningsReportDetailsWrapper: FC<Props> = ({
  earning,
  onClose,
  companyLogoAndName,
  previousEarnings,
  isGettingPreviousEarnings,
  getPreviousEarnings,
}: Props): JSX.Element => {
  const previousReportsKey = getPreviousEarningsCacheKey({ symbol: earning.symbol, beforeDate: earning.date });
  // Fetched newest-first (that's how the latest 3 are selected), displayed oldest-first.
  const previousReports = [...(previousEarnings[previousReportsKey] ?? [])].reverse();
  const logoAndName = companyLogoAndName[earning.symbol];

  useEffect(() => {
    getPreviousEarnings({ symbol: earning.symbol, beforeDate: earning.date });
  }, [earning.symbol, earning.date]);

  return (
    <EarningsReportDetails
      earning={earning}
      logo={logoAndName?.logo}
      logoUrl={logoAndName?.url}
      companyName={logoAndName?.name}
      previousReports={previousReports}
      isLoadingPrevious={isGettingPreviousEarnings && !previousReports.length}
      onClose={onClose}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  companyLogoAndName: state.fundamental.companyLogoAndName,
  previousEarnings: state.fundamental.previousEarnings,
  isGettingPreviousEarnings: isCallStatusPending(FundamentalCall.getPreviousEarnings, state.fundamental.statusByCall),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  getPreviousEarnings: (payload: GetPreviousEarningsPayload) => dispatch(getPreviousEarningsData(payload)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(EarningsReportDetailsWrapper);
